import { createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateApi } from "../../../shared/utils/KyApi";
import { ListGroupsResponse } from "../../../types/apiKey";

export const fetchUserGroups = createAsyncThunk<
  ListGroupsResponse,
  { IncludeGroupsAsMember?: boolean } | void,
  { rejectValue: string }
>("groups/fetchUserGroups", async (args, { rejectWithValue }) => {
  try {
    let url = "api/xdp/v1/user/groups";
    if (args && args.IncludeGroupsAsMember) {
      url += "?IncludeGroupsAsMember=true";
    }
    const response = await PrivateApi().get(url).json<ListGroupsResponse>();
    return response;
  } catch (error) {
    const errorMsg =
      error instanceof Error ? error.message : "Failed to fetch groups";
    return rejectWithValue(errorMsg);
  }
});
